let activeVideo: HTMLVideoElement | null = null;
let pauseActiveVideo: (() => void) | null = null;
const loaderDelay = 120;

function initVideoCard(card: HTMLElement) {
  const media = card.querySelector<HTMLElement>('.video-card__media');
  const video = card.querySelector<HTMLVideoElement>('.video-card__video');
  const button = card.querySelector<HTMLButtonElement>('.video-card__play');
  const source = video?.dataset.src;

  if (!media || !video || !button || !source) {
    return;
  }

  let playAttempt = 0;
  let loaderTimer: number | null = null;

  const clearLoaderTimer = () => {
    if (loaderTimer !== null) {
      window.clearTimeout(loaderTimer);
      loaderTimer = null;
    }
  };

  const pause = () => {
    playAttempt += 1;
    clearLoaderTimer();
    card.classList.remove('is-loading');
    video.pause();
    video.currentTime = 0;

    if (activeVideo === video) {
      activeVideo = null;
      pauseActiveVideo = null;
    }
  };

  const play = (deferLoader = false) => {
    const attempt = ++playAttempt;
    clearLoaderTimer();
    card.classList.remove('is-loading');

    if (activeVideo && activeVideo !== video) {
      pauseActiveVideo?.();
    }

    activeVideo = video;
    pauseActiveVideo = pause;
    video.muted = false;

    if (!video.src) {
      video.src = source;
      video.load();
    }

    if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
      if (deferLoader) {
        loaderTimer = window.setTimeout(() => {
          if (attempt === playAttempt && video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
            card.classList.add('is-loading');
          }
        }, loaderDelay);
      } else {
        card.classList.add('is-loading');
      }
    }

    video.play().catch(() => {
      if (attempt === playAttempt) {
        clearLoaderTimer();
        card.classList.remove('is-loading', 'is-playing');
      }
    });
  };

  video.addEventListener('playing', () => {
    clearLoaderTimer();
    card.classList.remove('is-loading');
    card.classList.add('is-playing');
  });
  video.addEventListener('pause', () => {
    clearLoaderTimer();
    card.classList.remove('is-loading', 'is-playing');
  });
  video.addEventListener('error', () => {
    clearLoaderTimer();
    card.classList.remove('is-loading');
  });
  card.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'mouse') {
      play(true);
    }
  });
  card.addEventListener('pointerleave', (event) => {
    if (event.pointerType === 'mouse') {
      pause();
    }
  });
  card.addEventListener('click', () => {
    if (video.paused) {
      play();
    } else {
      pause();
    }
  });
}

export function videoCards() {
  document.querySelectorAll<HTMLElement>('.js-video-card').forEach(initVideoCard);
}
